import React from 'react';
import PropTypes from 'prop-types';
import s from './ElectionStatusCard.scss';
import DataBar from '../../common/DataBar';
import ElectionBattle from '../../common/ElectionBattle/ElectionBattle';
import LiveblogUpdates from '../../common/LiveblogUpdates/LiveblogUpdates';
import AlliancePopup from '../../common/AlliancePopup/AlliancePopup';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
import SortSelect from '../../../../components_v2/common/SortSelect';
import DataBarsWrapper from '../../common/DataBarsWrapper/DataBarsWrapper';
import StatusCardTitle from '../../common/StatusCardTitle/StatusCardTitle';
import ErrorBoundary from '../../../ErrorBoundary/ErrorBoundary';

class ElectionStatusCard extends React.Component {
  constructor(props) {
    super(props);
    let activeTab = '';
    if (this.props?.config?.view === 'both' || !this.props?.config?.view) {
      activeTab = 1;
    } else if (this.props?.config?.view === 'party_sel') {
      activeTab = 1;
    } else if (this.props?.config?.view === 'alliance_sel') {
      activeTab = 2;
    } else {
      activeTab = 1;
    }
    this.state = {
      selectedSource: this.props?.sortedData?.selectedSource || '',
      activeTab,
    };
    this.electionBattleChildRef = React.createRef();
  }

  componentDidMount() {
    this.allianceInfoWrapperRef = React.createRef();
    document.addEventListener('click', this.closeAllianceInfo);
    const scrollableElectionBattle = this.electionBattleChildRef.current;

    if (scrollableElectionBattle) {
      scrollableElectionBattle.addEventListener('wheel', this.stopPropagation);
      scrollableElectionBattle.addEventListener(
        'touchmove',
        this.stopPropagation,
      );
    }
  }

  stopPropagation = e => {
    e.stopPropagation();
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.closeAllianceInfo);
    const scrollableElectionBattle = this.electionBattleChildRef.current;

    if (scrollableElectionBattle) {
      scrollableElectionBattle.removeEventListener(
        'wheel',
        this.stopPropagation,
      );
      scrollableElectionBattle.removeEventListener(
        'touchmove',
        this.stopPropagation,
      );
    }
  }

  handleSourceOnChange = e => {
    this.setState({ selectedSource: e });
    // eslint-disable-next-line no-nested-ternary
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'exitpoll_widget',
      category: this.props?.config?.name || 'Assembly Elections',
      label: e.name,
    });
  };

  setActiveTab = event => {
    if (!event || !event.target) {
      return;
    }
    const tabNum = event.target.getAttribute('data-tab');
    this.setState({
      activeTab: tabNum ? Number(tabNum) : this.state.activeTab,
    });
  };

  closeAllianceInfo = e => {
    if (
      this.allianceInfoWrapperRef &&
      this.allianceInfoWrapperRef.current &&
      !this.allianceInfoWrapperRef.current.contains(e.target) &&
      this.state.showAllianceInfo
    ) {
      this.setState({ showAllianceInfo: false });
    }
  };

  toggleAllianceInfoPopup = allianceMap => {
    const { showAllianceInfo } = this.state;
    const {
      setAlliancePopUpData,
      isWapView,
      electionwdtWap,
      hideLiveblog,
    } = this.props;
    if (isWapView && electionwdtWap && hideLiveblog) {
      setAlliancePopUpData(allianceMap);
    } else if (isWapView && !electionwdtWap && !hideLiveblog) {
      setAlliancePopUpData(allianceMap);
    } else {
      this.setState({ showAllianceInfo: !showAllianceInfo });
    }
  };

  render() {
    const {
      config,
      data,
      isExitPoll,
      starCandidateData,
      showResultWdtBtn,
      hideBattle,
      numberOfStates,
      isStarcnd,
      hideStarCandidate,
      hideLiveblog,
      hideLink,
      sortedData,
      noMinHeight,
    } = this.props;

    const {
      sortedPartyViewData,
      sortedAllianceViewData,
      leadingAllianceObj,
      leadingPartyObj,
      activeSeats,
      countOfLeadPlusWins,
      allianceMap,
      finalSourceData,
      exitPollSource,
      majority,
    } = sortedData;

    const { selectedSource } = this.state;

    const { activeTab, showAllianceInfo } = this.state;

    const leadingObj = activeTab === 1 ? leadingPartyObj : leadingAllianceObj;

    return (
      <>
        <div className="boxStyle">
          <StatusCardTitle
            hideLink={hideLink}
            name={config.name}
            path={config.path}
          />
          {config.hideAllianceView === '0' &&
            !isExitPoll && (
              <div className={s.partyInfo}>
                <ul onClick={this.setActiveTab}>
                  {allianceMap &&
                    Array.isArray(allianceMap) &&
                    allianceMap.length > 0 && (
                      <li
                        className={`${activeTab === 2 ? s.active : ''} ${
                          s.allianceView
                        }`}
                        data-tab="2"
                      >
                        Alliance View
                        <div
                          className={s.allianceInfo}
                          ref={this.allianceInfoWrapperRef}
                        >
                          {!this.props.wgtclient && (
                            <span
                              onClick={() =>
                                this.toggleAllianceInfoPopup(allianceMap)
                              }
                            >
                              <i className={s.icon}>i</i>
                            </span>
                          )}

                          {showAllianceInfo && (
                            <ErrorBoundary>
                              <AlliancePopup
                                allianceMap={allianceMap}
                                toggleAllianceInfoPopup={() =>
                                  this.toggleAllianceInfoPopup(allianceMap)
                                }
                              />
                            </ErrorBoundary>
                          )}
                        </div>
                      </li>
                    )}
                  <li className={activeTab === 1 ? s.active : ''} data-tab="1">
                    Party View
                  </li>
                </ul>
              </div>
            )}

          {isExitPoll &&
            selectedSource?.name && (
              <div className={s.sortSearchWrap}>
                <ErrorBoundary>
                  <SortSelect
                    options={exitPollSource}
                    onSelect={this.handleSourceOnChange}
                    selectedOption={selectedSource}
                    placeHolder="Source"
                    typeTwoStyle
                  />
                </ErrorBoundary>
              </div>
            )}
          {this.props.showbarchart && (
            <div className="exitPollWrap">
              {isExitPoll &&
                finalSourceData &&
                exitPollSource &&
                Array.isArray(exitPollSource) &&
                exitPollSource.length > 0 && (
                  <ErrorBoundary>
                    <DataBarsWrapper
                      totalSeats={activeSeats}
                      majority={majority}
                      exitPoll={isExitPoll}
                      noMinHeight={noMinHeight}
                      infoMsg={config?.infoMsg}
                    >
                      {selectedSource?.name &&
                        finalSourceData[selectedSource.name] &&
                        Array.isArray(finalSourceData[selectedSource.name]) &&
                        finalSourceData[selectedSource.name].length > 0 &&
                        finalSourceData[selectedSource.name].map(party => (
                          <ErrorBoundary>
                            <DataBar
                              color={party.color}
                              name={party.an}
                              ws={party.ls}
                              wsc={party.wsc}
                              ttl_seat={activeSeats}
                            />
                          </ErrorBoundary>
                        ))}
                    </DataBarsWrapper>
                  </ErrorBoundary>
                )}
              {!isExitPoll && (
                <>
                  {activeTab === 1 && (
                    <ErrorBoundary>
                      <DataBarsWrapper
                        totalSeats={activeSeats}
                        majority={majority}
                        noMinHeight={noMinHeight}
                        countOfLeadPlusWins={countOfLeadPlusWins}
                        infoMsg={config?.infoMsg}
                      >
                        {sortedPartyViewData &&
                          Array.isArray(sortedPartyViewData) &&
                          sortedPartyViewData.length &&
                          sortedPartyViewData.map(party => (
                            <ErrorBoundary>
                              <DataBar
                                color={party.color || party.cc}
                                name={party.an}
                                ws={
                                  typeof party?.ls === 'number' &&
                                  typeof party?.ls === 'number'
                                    ? party.ls + party.ws
                                    : 0
                                }
                                ttl_seat={activeSeats}
                              />
                            </ErrorBoundary>
                          ))}
                      </DataBarsWrapper>
                    </ErrorBoundary>
                  )}
                  {activeTab === 2 && (
                    <ErrorBoundary>
                      <DataBarsWrapper
                        totalSeats={activeSeats}
                        majority={majority}
                        noMinHeight={noMinHeight}
                        countOfLeadPlusWins={countOfLeadPlusWins}
                        infoMsg={config?.infoMsg}
                      >
                        {sortedAllianceViewData &&
                          Array.isArray(sortedAllianceViewData) &&
                          sortedAllianceViewData.length &&
                          sortedAllianceViewData.map(party => (
                            <ErrorBoundary>
                              <DataBar
                                color={party.color || party.cc}
                                name={party.an}
                                ws={
                                  typeof party?.ls === 'number' &&
                                  typeof party?.ls === 'number'
                                    ? party.ls + party.ws
                                    : 0
                                }
                                ttl_seat={activeSeats}
                              />
                            </ErrorBoundary>
                          ))}
                      </DataBarsWrapper>
                    </ErrorBoundary>
                  )}
                </>
              )}
              {isExitPoll &&
                exitPollSource &&
                Array.isArray(exitPollSource) &&
                exitPollSource.length === 0 && (
                  <div className="noDataFound">Exit Polls Awaited</div>
                )}
            </div>
          )}
          {!isExitPoll && (
            <div className={`${s.parties} parties`}>
              <div className={s.electionFooter}>
                <div className="electionFooterResult">
                  <div className={s.partyResult}>
                    <p>
                      {countOfLeadPlusWins?.winCount === activeSeats
                        ? 'Results'
                        : 'Leads + Wins'}
                      {': '}
                      <span>
                        {countOfLeadPlusWins?.leadPlusWinCount || '0'}/{data?.ttl_seat ||
                          '0'}
                      </span>
                    </p>
                  </div>
                  <div className={s.partyResult}>
                    <strong
                      className={`${s.party}`}
                      style={{ color: leadingObj?.color }}
                    >
                      {leadingObj?.party}
                    </strong>{' '}
                    {leadingObj?.text}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!isExitPoll &&
            !hideLiveblog &&
            config.liveblog && (
              <div className={s.liveblog}>
                <ErrorBoundary>
                  <LiveblogUpdates
                    isWapView={this.props.isWapView}
                    liveblogData={config.liveblog}
                    storiesCount={1}
                    hideContent
                    themeClass
                    electionStateName={config.name}
                    hideBattle
                  />
                </ErrorBoundary>
              </div>
            )}
          {!this.props.isWapView &&
            (isStarcnd || (!hideBattle && !isExitPoll)) &&
            !hideStarCandidate &&
            starCandidateData &&
            starCandidateData?.cnt_rslt &&
            Array.isArray(starCandidateData?.cnt_rslt) &&
            starCandidateData?.cnt_rslt.length > 0 && (
              <ErrorBoundary>
                <ElectionBattle
                  isWapView={this.props.isWapView}
                  starCandidateData={starCandidateData?.cnt_rslt.filter(
                    candidate =>
                      candidate.star === true &&
                      candidate.starMeta &&
                      candidate.starMeta.TOI === '1',
                  )}
                  showResultWdtBtn={showResultWdtBtn}
                  state={config.key}
                  numberOfStates={numberOfStates}
                  isStarcnd={isStarcnd}
                />
              </ErrorBoundary>
            )}
        </div>
        {this.props.isWapView &&
          (isStarcnd || (!hideBattle && !isExitPoll)) &&
          !hideStarCandidate &&
          starCandidateData &&
          starCandidateData?.cnt_rslt &&
          Array.isArray(starCandidateData?.cnt_rslt) &&
          starCandidateData?.cnt_rslt.length > 0 && (
            <div
              className={s.battleWrapperMobile}
              ref={this.electionBattleChildRef}
            >
              <ErrorBoundary>
                <ElectionBattle
                  isWapView={this.props.isWapView}
                  starCandidateData={starCandidateData?.cnt_rslt.filter(
                    candidate =>
                      candidate.star === true &&
                      candidate.starMeta &&
                      candidate.starMeta.TOI === '1',
                  )}
                  showResultWdtBtn={showResultWdtBtn}
                  state={config.key}
                  numberOfStates={numberOfStates}
                  isStarcnd={isStarcnd}
                />
              </ErrorBoundary>
            </div>
          )}
      </>
    );
  }
}

ElectionStatusCard.propTypes = {
  data: PropTypes.shape({}),
  config: PropTypes.shape({}).isRequired,
  isExitPoll: PropTypes.bool,
  isWapView: PropTypes.bool,
  showbarchart: PropTypes.bool,
  wgtclient: PropTypes.string,
  electionwdtWap: PropTypes.bool,
};
ElectionStatusCard.defaultProps = {
  data: {},
  isExitPoll: false,
  isWapView: false,
  showbarchart: true,
  electionwdtWap: false,
  wgtclient: '',
};

export default ElectionStatusCard;
